module.exports = __webpack_public_path__ + "media/images/new_landing/favicon/android-chrome-192x192-27d90396a07704332b8f98538947ba40.png";